export default __webpack_public_path__ + "static/bg-feature-light-84c89b838942626460cd84afa3030560.png";